import React from "react";
import _ from "lodash";
import LoadingUI from "components/common/LoadingUI";
import ModalWrapper from "components/common/ModalWrapper";
import { UnitAPI } from "apis";
import AdUnitBasicCard from "./AdUnitBasicCard";
import { transformUnitMoneyMetrics } from "helpers/Snapshot";

class UnitHasChildrenModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errmsg: "",
      isLoading: false,
      childSnapshots: [],
    };
  }

  componentDidMount() {
    this.handleGetData();
  }

  async handleGetData() {
    // 1. get child snapshots
    this.setState({ isLoading: true, errmsg: "" });

    try {
      const { unit } = this.props;
      let r = await UnitAPI.getUnitSnapshotReports({
        unitIds: unit.child_units,
      });
      r = _.map(r, (unit) => {
        if (_.has(unit, "snapshot")) {
          unit.snapshot = transformUnitMoneyMetrics(unit.snapshot, true);
        }
        return unit;
      });
      this.setState({ childSnapshots: r });
    } catch (err) {
      console.error(err);
      this.setState({ errmsg: err.toString() });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { unit, networkId, networkName } = this.props;

    const { isLoading, errmsg, childSnapshots } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        handleClose={this.props.handleClose}
        width={"81.25rem"}
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
      >
        <div className="w-full">
          {errmsg !== "" && <div className="text-red-800">{errmsg}</div>}

          {isLoading ? (
            <LoadingUI></LoadingUI>
          ) : (
            <div className="flex justify-between gap-4">
              <div className="border-2 border-yellow-400">
                <div className="text-center font-bold uppercase tracking-wide text-gray-600">
                  Parent
                </div>
                <div className="text-xs text-gray-700">
                  <AdUnitBasicCard
                    unit={unit}
                    networkId={networkId}
                    networkName={networkName}
                  ></AdUnitBasicCard>
                </div>
              </div>
              <div className="border-2">
                <div className="text-center font-bold uppercase tracking-wide text-gray-600">
                  Children ({childSnapshots.length})
                </div>
                <div style={{ maxHeight: "41.25rem", overflowY: "auto" }}>
                  {childSnapshots.map((s) => {
                    const unit = s.snapshot || s.info;
                    const isBasicInfoOnly = _.has(s, "info");
                    return (
                      <div
                        key={`${unit.ext_gam_unit_id}`}
                        className="mb-6 border-b-4 border-gray-600"
                      >
                        <AdUnitBasicCard
                          unit={unit}
                          networkId={networkId}
                          networkName={networkName}
                          isBasicInfoOnly={isBasicInfoOnly}
                        ></AdUnitBasicCard>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

export default UnitHasChildrenModal;
